import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import slTranslation from './locales/sl/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      sl: {
        translation: slTranslation
      }
      // Future languages will be added here
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback if translation missing
    interpolation: {
      escapeValue: false // React already escapes by default
    },
    react: {
      useSuspense: false // Prevent suspense-related issues during init
    }
  });

export default i18n;